import { useEffect } from 'react';
import { useDrawerStore } from '../../store/useDrawerStore';
import { DRAWER_COMPONENTS_MAP } from '../../lib/constants/drawer.constants';

export const GlobalDrawerRenderer = () => {
  const { drawers, closeDrawer } = useDrawerStore();

  // (선택 사항) Drawer가 열렸을 때 스크롤을 막을지 결정
  useEffect(() => {
    if (drawers.length > 0) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'auto';
      };
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [drawers.length]);

  return (
    <>
      {drawers.map(({ id, key, props }) => {
        const SpecificDrawerComponent = DRAWER_COMPONENTS_MAP[key];

        if (!SpecificDrawerComponent) {
          // ... (warn)
          return null;
        }
        
        return (
          <SpecificDrawerComponent
            key={id}
            id={id}
            onClose={() => closeDrawer(id)}
            {...props}
          />
        );
      })}
    </>
  );
};